import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  assignmentRequestRequest,
  assignmentRequestSuccess,
  assignmentRequestFailure,
} from '../reducers/assignmentRequest';
import { API_LINK } from '../../constants';
import {getUserProgramsFullRequest} from '../reducers/userProgramsFull'; 
import {assignmentRequest} from '../reducers/assignmentRequest';


const API = `${API_LINK}`;

function* assignmentRequestAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const { selectedContentId: contentId, selectedAssessmentId } = state.userProgramsFullReducer;
  
  const user_id = userId
  const survey_id = selectedAssessmentId
  
  const requestType = state.assignmentRequest.assignmentRequestType;
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}api/surveyRequest`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        user_id,
        survey_id,
        requestType
      },
    }),
  );
  console.log('ZXCCALL:')
  return response;
}

function* assignmentRequestSaga() {
  try {
   
    const response = yield call(assignmentRequestAxios);
    console.log('ZXCCALL:', response.data)
    yield put(assignmentRequestSuccess(response.data));
    yield put(getUserProgramsFullRequest());
  } catch (error) {
    yield put(assignmentRequestFailure(error));
  }
}

export function* watcherAssignmentRequestSaga() {
  console.log('API_ASSIGNMENT_WATCHER')
  yield takeLatest(assignmentRequestRequest().type, assignmentRequestSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/assignmentRequest.js